/* Вкладки всплывающего окна проигрывателя */
export const listSections = [
  'Радиоэфир',
  'Программы',
  'Аудикниги',
  'Подкасты',
] as const;
